// src/components/legal/TermsOfService.jsx
import SharedHeader from '../layout/SharedHeader';

const TermsOfService = () => {
  return (
    <div className="min-h-screen bg-neutral-white">
      <SharedHeader />
      <div className="max-w-4xl mx-auto py-12 px-4 sm:px-6 lg:px-8">
        <div className="bg-white shadow rounded-lg p-8">
          <h1 className="text-3xl font-bold mb-8">Terms of Service</h1>
          
          <div className="prose prose-blue max-w-none">
            <h2>1. Acceptance of Terms</h2>
            <p>By accessing and using Aviation Advisor AI, you agree to be bound by these Terms of Service and all applicable laws and regulations.</p>

            <h2>2. Use License</h2>
            <p>Permission is granted to temporarily access Aviation Advisor AI for personal, non-commercial use. This license does not include:</p>
            <ul>
              <li>Modifying or copying the materials</li>
              <li>Using the materials for commercial purposes</li>
              <li>Attempting to reverse engineer any software contained on Aviation Advisor AI</li>
              <li>Removing any copyright or proprietary notations from the materials</li>
            </ul>

            <h2>3. Disclaimer</h2>
            <p>The materials on Aviation Advisor AI are provided on an 'as is' basis. Aviation Advisor AI makes no warranties, expressed or implied, and hereby disclaims and negates all other warranties including, without limitation, implied warranties or conditions of merchantability, fitness for a particular purpose, or non-infringement of intellectual property or other violation of rights.</p>

            <h2>4. Limitations</h2>
            <p>In no event shall Aviation Advisor AI or its suppliers be liable for any damages (including, without limitation, damages for loss of data or profit, or due to business interruption) arising out of the use or inability to use Aviation Advisor AI.</p>

            <h2>5. Revisions</h2>
            <p>Aviation Advisor AI may revise these terms of service at any time without notice. By using this website you are agreeing to be bound by the then current version of these terms of service.</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TermsOfService;